import { render, staticRenderFns } from "./TokenAdd.vue?vue&type=template&id=91a1c5bc"
import script from "./TokenAdd.vue?vue&type=script&lang=js"
export * from "./TokenAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports